import { MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import FullScreenLoader from '../atoms/FullScreenLoader';
import { CURRENCY_OPTIONS } from '../../constants/roles';
import { FormPasswordField, FormSelectField, FormTextField } from '../molecules/form-elements';
import StyledForm from '../forms/shared/StyledForm';
import { useCreateBOUsersForm } from '../../hooks/useCreateBOUsersForm';

const CreateBOUsersForm = () => {
  const {
    t,
    control,
    handleSubmit,
    errors,
    isSubmitting,
    isLoading,
    isAdmin,
    isAgent,
    enableSelectManagers,
    localizedRoleOptions,
    managerOptions,
    closeModal,
    onSubmit,
  } = useCreateBOUsersForm();

  if (isLoading) {
    return <FullScreenLoader open={isLoading} />;
  }

  return (
    <StyledForm
      title={t('createNewUser')}
      submitTitle={t('register.register')}
      onSubmit={handleSubmit(onSubmit)}
      isSubmitting={isSubmitting}
      onClose={closeModal}
    >
      {isAgent ? (
        <FormTextField
          key='username'
          name='username'
          control={control}
          label={t('register.username')}
          fullWidth
          type='text'
          error={!!errors.username}
          helperText={errors.username?.message}
          disabled={isSubmitting}
          slotProps={{ htmlInput: { autoComplete: 'off' } }}
        />
      ) : (
        <FormTextField
          key='email'
          name='email'
          control={control}
          label={t('register.email')}
          fullWidth
          type='text'
          error={!!errors.email}
          helperText={errors.email?.message}
          disabled={isSubmitting}
          slotProps={{ htmlInput: { autoComplete: 'off' } }}
        />
      )}
      <FormPasswordField
        key='password'
        name='password'
        control={control}
        label={t('register.password')}
        error={!!errors.password}
        helperText={errors.password?.message}
        disabled={isSubmitting}
        slotProps={{ htmlInput: { autoComplete: 'new-password' } }}
      />
      <FormTextField
        key='firstName'
        name='firstName'
        control={control}
        label={t('register.firstName')}
        fullWidth
        error={!!errors.firstName}
        helperText={errors.firstName?.message}
        disabled={isSubmitting}
        slotProps={{ htmlInput: { autoComplete: 'off' } }}
      />
      <FormTextField
        key='lastName'
        name='lastName'
        control={control}
        label={t('register.lastName')}
        fullWidth
        error={!!errors.lastName}
        helperText={errors.lastName?.message}
        disabled={isSubmitting}
        slotProps={{ htmlInput: { autoComplete: 'off' } }}
      />
      {isAdmin && (
        <FormSelectField
          key='groupName'
          name='groupName'
          control={control}
          label={t('register.role')}
          error={!!errors.groupName}
          helperText={errors.groupName?.message}
          options={localizedRoleOptions}
          FormControlProps={{
            fullWidth: true,
            disabled: isSubmitting,
          }}
        />
      )}
      {enableSelectManagers && (
        <FormSelectField
          key='managerId'
          name='managerId'
          control={control}
          label={t('register.assignToManager')}
          error={!!errors.managerId}
          helperText={errors.managerId?.message}
          options={managerOptions}
          FormControlProps={{
            fullWidth: true,
            disabled: isSubmitting,
          }}
        />
      )}
      <FormControl fullWidth disabled={isSubmitting}>
        <InputLabel id='currency-label'>{t('register.currency')}</InputLabel>
        <Select labelId='currency-label' label={t('register.currency')} value={CURRENCY_OPTIONS[0].value}>
          {CURRENCY_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </StyledForm>
  );
};

export default CreateBOUsersForm;
